<div *ngIf="items">
    <div 
        *ngIf="showHeader"
        class="list-header row">
        <div class="col-8">
            <h1 class="list-header-title">
                {{ headingText | translate }}
            </h1>
        </div>
    </div>
    <div *ngIf="showSearch" 
        class="row mb-4">
        <div class="col-md-12 col-xl-6">
            <div class="list-search-container ">
                <i class="fas fa-search list-search-icon"></i>
                <form class="list-search-form align-items-center">
                    <input (input)="searchTextChanged($event.target.value)"
                        class="list-search-input"
                        placeholder="{{ 'Search' | translate }}"/>
                </form>
            </div>
        </div>
    </div>
    <div class="row expanded-list">
        <div class="col-md-12 col-xl-6">
            <div class="row">
                <div class="w-100">
                    <div *ngFor="let i of items | filterBy: searchTextFilterObject;"
                         class="col-12 list-item-container">
                        <a [routerLink]="i.link"
                           [routerLinkActive]="['active']" 
                           class="item d-flex py-2">
                            <span class="mx-4">
                                <span class="list-item-title">{{i.title | translate}}</span>
                                <span *ngIf="i.showLabel" class="ml-2">
                                    <i class="fa-thin fa-bracket-round"></i>
                                    <span class="list-item-label">{{i.label}}</span>
                                    <i class="fa-thin fa-bracket-round-right"></i>
                                </span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>